import React from "react";
import Banner from "../components/Banner";
import focus from "./focus.png";

function Focus() {
  return (
    <>
      <div
        className="text-white text-center d-flex align-items-center"
        style={{
          minHeight: "60vh",
          background: `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${focus}) center/cover`,
        }}
      >
        <div className="container">
          <h1 className="display-5 fw-bold">FOCUS AREAS (PILLARS)</h1>
        </div>
      </div>

      <section className="py-5">
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-4" style={{ color: "#1155cc" }}>
            ENVIRONMENTAL PROTECTION
          </h2>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            What This Means
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Environmental Protection focuses on the conservation and
                responsible management of natural ecosystems, including forests,
                rivers, wetlands, wildlife, and coastal and marine environments.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Why It Matters
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Healthy ecosystems provide clean air, water, food, and
                protection against environmental hazards. Environmental
                degradation threatens biodiversity, livelihoods, and national
                development.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            SEA’S 2050 Focus
          </h2>

          {/* ✅ FIXED LIST SECTION */}
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9 text-start">
              <ul
                className="fs-5 text-muted mb-4"
                style={{
                  paddingLeft: "1.5rem",
                  listStylePosition: "outside",
                }}
              >
                <li className="mb-2">Forest conservation and reforestation</li>
                <li className="mb-2">
                  Protection of water bodies and watersheds
                </li>
                <li className="mb-2">Biodiversity and wildlife preservation</li>
                <li className="mb-2">Pollution control and waste management</li>
                <li className="mb-2">
                  Ecosystem restoration and conservation strategies
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-4" style={{ color: "#1155cc" }}>
            CLIMATE CHANGE & RESILIENCE
          </h2>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            What This Means
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                This pillar examines how climate change affects communities,
                ecosystems, and economic sectors, and how Sierra Leone can adapt
                and build resilience to climate-related risks.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Why It Matters
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Climate impacts such as flooding, coastal erosion, droughts, and
                extreme weather threaten lives, infrastructure, and livelihoods.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            SEA’S 2050 Focus
          </h2>

          {/* ✅ FIXED LIST SECTION */}
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9 text-start">
              <ul
                className="fs-5 text-muted mb-4"
                style={{
                  paddingLeft: "1.5rem",
                  listStylePosition: "outside",
                }}
              >
                <li className="mb-2">
                  Climate risk assessment and vulnerability analysis
                </li>
                <li className="mb-2">Adaptation and mitigation strategies</li>
                <li className="mb-2">
                  Disaster risk reduction and preparedness
                </li>
                <li className="mb-2">
                  Community resilience and early warning systems
                </li>
                <li className="mb-2">Climate-informed development planning</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-4" style={{ color: "#1155cc" }}>
            SUSTAINABLE LIVELIHOODS
          </h2>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            What This Means
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Sustainable Livelihoods emphasizes economic activities that
                support people’s wellbeing while protecting natural resources
                for future generations.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Why It Matters
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Unsustainable practices may offer short-term benefits but lead
                to long-term environmental and economic loss.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            SEA’S 2050 Focus
          </h2>

          {/* ✅ FIXED LIST SECTION */}
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9 text-start">
              <ul
                className="fs-5 text-muted mb-4"
                style={{
                  paddingLeft: "1.5rem",
                  listStylePosition: "outside",
                }}
              >
                <li className="mb-2">Sustainable agriculture and fisheries</li>
                <li className="mb-2">Green jobs and innovation</li>
                <li className="mb-2">Responsible mining and resource use</li>
                <li className="mb-2">
                  Community-based natural resource management
                </li>
                <li className="mb-2">
                  Poverty reduction linked to environmental sustainability
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-4" style={{ color: "#1155cc" }}>
            URBAN & RURAL DEVELOPMENT
          </h2>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            What This Means
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                This pillar addresses how cities, towns, and rural areas grow
                and develop in harmony with environmental and social needs.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Why It Matters
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Unplanned development can lead to land degradation, flooding,
                poor housing, and inadequate infrastructure.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            SEA’S 2050 Focus
          </h2>

          {/* ✅ FIXED LIST SECTION */}
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9 text-start">
              <ul
                className="fs-5 text-muted mb-4"
                style={{
                  paddingLeft: "1.5rem",
                  listStylePosition: "outside",
                }}
              >
                <li className="mb-2">Sustainable land-use planning</li>
                <li className="mb-2">
                  Climate-resilient housing and infrastructure
                </li>
                <li className="mb-2">Rural development and service delivery</li>
                <li className="mb-2">Urban growth management</li>
                <li className="mb-2">
                  Transportation, water, and sanitation systems
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container text-center">
          {/* Heading */}
          <h2 className="fw-bold mb-4" style={{ color: "#1155cc" }}>
            GOVERNANCE & POLICY
          </h2>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            What This Means
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Governance & Policy focuses on the systems, laws, and
                institutions responsible for managing environmental resources
                and enforcing regulations.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Why It Matters
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                Strong institutions and transparent policies ensure
                accountability, fairness, and effective implementation of
                environmental strategies.
              </p>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            SEA’S 2050 Focus
          </h2>

          {/* ✅ FIXED LIST SECTION */}
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9 text-start">
              <ul
                className="fs-5 text-muted mb-4"
                style={{
                  paddingLeft: "1.5rem",
                  listStylePosition: "outside",
                }}
              >
                <li className="mb-2">
                  Environmental laws and policy frameworks
                </li>
                <li className="mb-2">Institutional capacity building</li>
                <li className="mb-2">
                  Transparency and accountability mechanisms
                </li>
                <li className="mb-2">
                  Stakeholder participation in decision-making
                </li>
                <li className="mb-2">
                  Monitoring, evaluation, and compliance systems
                </li>
              </ul>
            </div>
          </div>

          <h2 className="mb-4" style={{ fontStyle: "italic" }}>
            Integrated Approach
          </h2>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <p className="fs-5 text-muted mb-3">
                These five pillars are interconnected. Progress in one area
                strengthens the others. SEA’S 2050 adopts an integrated approach
                to ensure balanced, inclusive, and sustainable development
                toward 2050
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Focus;
